import { DataGrid } from "@mui/x-data-grid";
import {
  fKeyTabInput,
  hasValueInErrorMessage,
  userBasedHideField,
} from "../../../Utility/Utilitys";
import {
  CmpDatePickerField,
  CmpSelectField,
  CmpSelectArrField,
  CmpInputField,
  CmpCheckboxField,
  CmpTypographyField,
  CmpDatePickerField001,
} from "../../../Component/Common/ToolBox/ToolBox";

import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Grid from "@mui/material/Grid";
import { CmpDatePickerField001V1, CmpSelectArrFieldV1, CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";

export default function GCSalesHead({
  sTax,
  sTransItemStockObj,
  xTransItemStockShow,
  xOsAmount, 
  vRdxWmsHead,
  sLocation,  
  DocLoading,
  currency,
  selecType,
  sInvoiceTyp,
  sPayModeArr,
  fOnChangeSelectDocType,
  fOnChangeSelectCurr,
  fOnChangeInputDate,
  fOnChangeInputDateRefDate,
  fonChangeInput,
  fonChangeInputTaxType,
  fonChangeInputInvoiceType,
  fonChangeInputPayMode,
  fonChangeInputTaxable,
  fonChangeInput_CreditNote,
  fonChangeInput_A_DropShipment,
  fonChangeInput_Commity,
  fonChangeInput_Checkbox,  
  fonChangeInputLocation,
  sErrorMsg,
  sDetailGridData,
  sToggleGrid,
  GridDataSalesHistoryColumns,
  sGridSalesHistoryRowData,
  vMediaQuery,
  fonChangeInput_A_ECOM,
  inputReference,

  xPaymodeEnable,
  //GC customer
  xonChangeInputCustomer,
  xhandleClick,
  xrowDropdownSearch,
  xcolumnsDropdownSearch,
  xOnCellKeyDown,
  xOnRowClick,
  xToggleDropdown,
  xData,
  xOnChange,
  xDropdownObj,
  xOnKeyUp,
  sOSDetailObj
  //Gc old
}) {
  return (
    <div className="Wms-sales-invoice-head">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0.9, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0.9, md: 0.6 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12}  sm={12} md={4.5}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(sErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
           
            <Grid item xs={12}   sm={4} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxWmsHead.A_VocTyp}
                xOnChange={(e) => {
                  fOnChangeSelectDocType(e);
                }}
                xName={"A_VocTyp"}
                xData={DocLoading}
                xValueMember={""}
                xDispalyMember={""}
                xError={sErrorMsg?.A_VocTyp === "" ? false : true}
                xErrorMessage={sErrorMsg?.A_VocTyp}
                xDisable={
                  sDetailGridData.length > 0 || vRdxWmsHead.A_VocNo != 0
                }
                salespaddingReduce={true}
              // xOnKeyUp={xKey}
              />
            </Grid>
           
            <Grid item xs={12} sm={4}  md={6}>
              <CmpTextFieldV1
                xLabelText="Doc.No"
                xValue={vRdxWmsHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={sErrorMsg?.A_VocNo === "" ? false : true}
                xErrorMessage={sErrorMsg?.A_VocNo}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "A_PostDt");
                }}
              />
            </Grid>
          
            <Grid item xs={12}  sm={4} md={6}>
              <CmpTextFieldV1
                xLabelText="VAT Ref.No"
                xtabIndex={"3"}
                xValue={vRdxWmsHead.A_RefNo}
                xType={"text"} // text/number/password
                xName={"A_RefNo"}
                xReadOnly={true}
                xOnChange={(e) => {
                  fonChangeInput(e);
                }}
                xError={sErrorMsg?.A_RefNo === "" ? false : true}
                xErrorMessage={sErrorMsg?.A_RefNo}
              // xOnKeyUp={xKey}
              />
            </Grid>
            
            <Grid item xs={12}sm={4}   md={3}>
            <CmpDatePickerField001V1
                xLabelText="Doc.Date"
                xtabIndex={"2"}
                xref={inputReference}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxWmsHead.A_PostDt}
                xOnChange={fOnChangeInputDate}
                xName={"A_PostDt"}
                xError={sErrorMsg?.A_PostDt === "" ? false : true}
                xErrorMessage={sErrorMsg?.A_PostDt}
              // xOnKeyUp={(e) => {
              //   xFocusInput("A_RefDocNo");
              // }}
              />
            </Grid>

            
            <Grid item xs={12}  sm={4} md={3}>
              <CmpDatePickerField001V1
                xLabelText="Ref.Date"
                xValue={vRdxWmsHead.A_RefDt}
                xOnChange={(e) => {
                  fOnChangeInputDateRefDate(e);
                }}
                xName={"A_RefDt"}
                xError={sErrorMsg?.A_RefDt === "" ? false : true}
                xErrorMessage={sErrorMsg?.A_RefDt}
              // xOnKeyUp={(e) => {
              //   xFocusInput("Paymode");
              // }}
              />
            </Grid>
            <Grid item xs={6}  sm={4} md={3}>
              <CmpTextFieldV1
                xLabelText="Ref.No"
                xValue={vRdxWmsHead.No}
                xType={"text"} // text/number/password
                xName={"No"}
                xReadOnly={false}
                xOnChange={(e) => {
                  fonChangeInput(e);
                }}
                xError={sErrorMsg?.No === "" ? false : true}
                xErrorMessage={sErrorMsg?.No}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "A_Party");
                }}
              />

            </Grid>
            <Grid item xs={6}  sm={4}
             md={3}>
                <CmpSelectFieldV1
                  xLabelText="Currency"
                  xValue={vRdxWmsHead.A_Curr}
                  xOnChange={fOnChangeSelectCurr}
                  xName={"A_Curr"}
                  xData={currency}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg?.A_Curr === "" ? false : true}
                  xErrorMessage={sErrorMsg?.A_Curr}
                  xDisable={sDetailGridData.length > 0}

                // xDisable={true}
                />
              </Grid>
             
              <Grid item xs={6}  sm={4}
               md={3}>
                <CmpTextFieldV1
                 xLabelText="ExRate"
                xSize="small"
                  xValue={vRdxWmsHead.A_ExRate}
                  xType={"number"} // text/number/password
                  xName={"A_ExRate"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
                />
              </Grid>
              <Grid item xs={6}  sm={4}
               md={3}>
                <CmpSelectArrFieldV1
                  xLabelText="Paymode"
                  xValue={vRdxWmsHead.A_PayMode}
                  xOnChange={(e) => {
                    fonChangeInputPayMode(e);
                  }}
                  xName={"A_PayMode"}
                  xData={sPayModeArr}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg?.A_PayMode === "" ? false : true}
                  xErrorMessage={sErrorMsg?.A_PayMode}
                  xDisable={false}
                />
              </Grid>
          </Grid>
        </Grid>
        {sToggleGrid ? (
          <Grid item xs={12}   md={6}>
            <Grid
              container
              spacing={0}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className="align-items-start"
            >
              <div style={{ height: 170, width: "100%" }}>
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sGridSalesHistoryRowData}
                  columns={GridDataSalesHistoryColumns}
                  hideFooter={sGridSalesHistoryRowData.length < 100}
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12}   md={6}>
            <Grid
              container
              spacing={0.9}
              columnSpacing={{ xs: 0.9, sm: 0.9, md: 0.2 }}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className={
                hasValueInErrorMessage(sErrorMsg)
                  ? "align-items-center"
                  : "align-items-start"
              }
            >
              
              <Grid item xs={12} sm={12}   md={12}>
              <Grid container spacing={.9}>
              {!vMediaQuery&&  <Grid item xs={12}  sm={2} md={2} lg={2}  >
                <CmpTextFieldV1
                    xLabelText="Customer"
                      xValue={vRdxWmsHead.A_Party}
                      xType={"text"} // text/number/password
                      xName={"A_Party"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={sErrorMsg?.A_Party === "" ? false : true}
                      xErrorMessage={sErrorMsg?.A_Party}
                    />
                  </Grid>}
                  <Grid item xs={12} sm={10}
                   md={10} className="dropDowntoggle">
                      <GCToggleSearchV1
                  xLabelText="Customer Name"
                      xName={"A_PartyName"}
                      xType={"text"}
                      xValue={vRdxWmsHead.A_PartyName}
                      xReadOnly={false}
                      xOnChange={(e) => {
                        xonChangeInputCustomer(e);
                      }} //GCToggleSearch onchange main input
                      xOnKeyUp={(e) => {
                        xhandleClick(e, "customer");
                      }} //GCToggleSearch xOnKeyUp main input
                      xError={sErrorMsg?.A_PartyName === "" ? false : true}
                      xErrorMessage={sErrorMsg?.A_PartyName}
                      xMediaQuery={false}
                      xonClickbtn={xhandleClick} // GCToggleSearch onclick icon open div on main screen
                      xrows={xrowDropdownSearch} //GCToggleSearch-grid
                      xcolumns={xcolumnsDropdownSearch} //GCToggleSearch-grid
                      xRowCellClick={xOnCellKeyDown}
                      xRowClick={xOnRowClick}
                      xToggle={xToggleDropdown} //GCToggleSearch- true/false
                      xData={xData} //GCToggleSearch-select
                      xOnChangeDropdownInput={xOnChange} //GCToggleSearch -input
                      xDropdownObj={xDropdownObj} //GCToggleSearch -obj
                      xOnKeyUpDropdownInput={xOnKeyUp} //GCToggleSearch -Enter key and clickc detect
                      xtabIndex="5"
                    />
                  </Grid>
                </Grid>
              </Grid>
 
             { (!vMediaQuery || userBasedHideField())&&  <Grid item xs={4}   md={1.5}>
                <CmpTextFieldV1
                  xSize="small"
                  xLabelText="Party OS" 
                  xValue={sOSDetailObj.partyos < 0 ? "Cr =" : "Dr =" + sOSDetailObj.partyos}
                  xType={"text"} // text/number/password
                  xName={"partyos"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
                />
              </Grid>}
              { (!vMediaQuery || userBasedHideField())&&   <Grid item xs={4}   md={1.5}>
                <CmpTextFieldV1
                  xSize="small"
                  xLabelText="party PDC" 
                  xValue={sOSDetailObj.partypdc < 0 ? "Cr =" : "Dr =" + sOSDetailObj.partypdc}

                  xType={"text"} // text/number/password
                  xName={"partypdc"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
                />
              </Grid>}
              { (!vMediaQuery || userBasedHideField())&&  <Grid item xs={4}   md={2}>
                <CmpTextFieldV1
                    xSize="small"
                    xLabelText="Cr.Limit" 
                  xValue={sOSDetailObj.CrLimit}
                  xType={"text"} // text/number/password
                  xName={"CrLimit"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
                />
              </Grid>}
              { (!vMediaQuery || userBasedHideField())&&   <Grid item xs={4}   md={2}>
                <CmpTextFieldV1
              xSize="small"
               xLabelText="Party Net OS"
                  xValue={sOSDetailObj.partyNetOS < 0 ? "Cr =" : "Dr =" + sOSDetailObj.partyNetOS}
                  xType={"text"} // text/number/password
                  xName={"partyNetOS"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
                />
              </Grid>}
              { (!vMediaQuery || userBasedHideField())&&  <Grid item xs={4}   md={2}>
                <CmpTextFieldV1
                 xSize="small"
                 xLabelText="Cr.Limit.PRD" 
                  xValue={sOSDetailObj.CrlimitPRD}
                  xType={"text"} // text/number/password
                  xName={"CrlimitPRD"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
                />
              </Grid>}
              <Grid item xs={6}   md={1.5}>
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Route Name"}
                  xtextDecoration="underline"
                />
              </Grid>
              
             
              
           
              
              <Grid item xs={6} 
               md={3}>
                <CmpSelectFieldV1
                  xLabelText="Type"
                  xValue={vRdxWmsHead.A_Type}
                  xOnChange={(e) => {
                    fonChangeInput(e);
                  }}
                  xName={"A_Type"}
                  xData={selecType}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg?.A_Type === "" ? false : true}
                  xErrorMessage={sErrorMsg?.A_Type}
                  xDisable={sDetailGridData.length > 0}
                  xtabIndex={"6"}
                />
              </Grid>

             
              <Grid item xs={6} 
               md={3}>
                <CmpSelectFieldV1
                  xLabelText="Location"
                  xValue={vRdxWmsHead.A_Loc}
                  xOnChange={(e) => {
                    fonChangeInputLocation(e);
                  }}
                  xName={"A_Loc"}
                  xData={sLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg?.A_Loc === "" ? false : true}
                  xErrorMessage={sErrorMsg?.A_Loc}
                  xDisable={sDetailGridData.length > 0}
                />
              </Grid>

              
              <Grid item xs={6} 
               md={3}>
                <CmpSelectFieldV1
                  xLabelText="Tax Type"
                  xValue={vRdxWmsHead?.A_TaxType}
                  xOnChange={(e) => {
                    fonChangeInputTaxType(e);
                  }}
                  xName={"A_TaxType"}
                  xData={sTax}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg?.A_TaxType === "" ? false : true}
                  xErrorMessage={sErrorMsg?.A_TaxType}
                  xDisable={sDetailGridData.length > 0} //shinju ji
                // xDisable={true}
                />
              </Grid>
               <Grid item xs={6} 
               md={3}>
                <CmpSelectFieldV1
                  xLabelText="Invoice Type"
                  xValue={vRdxWmsHead?.A_InvoiceType}
                  xOnChange={(e) => {
                    fonChangeInputInvoiceType(e);
                  }}
                  xName={"A_InvoiceType"}
                  xData={sInvoiceTyp}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg?.A_InvoiceType === "" ? false : true}
                  xErrorMessage={sErrorMsg?.A_InvoiceType}
                  xDisable={sDetailGridData.length > 0} //shinju ji
                // xDisable={true}
                />
              </Grid>

              {vRdxWmsHead.A_DocStat === "ENTER" && false ? (
                <>
                  <Grid item xs={3} 
                   md={3}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"Net O/s Amt = " + xOsAmount.NetOsAmt}
                    />
                  </Grid>
                  <Grid item xs={3} 
                   md={3}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"PDC Amt =" + xOsAmount.PDCAmt}
                    />
                  </Grid>
                  <Grid item xs={3} 
                   md={3}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"Balance O/s Amt =" + xOsAmount.BalanceOsAmt}
                    />
                  </Grid>
                 
                </>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        )}
        <Grid item xs={12}   md={1.5}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 6 }}
            sx={{ marginTop: { md: 0, sm: "8px", xs: "8px" } }}
          // sx={{ flexDirection: "column", alignItems: "start", marginTop: { md: 0, sm: "8px", xs: "8px" } }}
          // className="ps-3"
          >
            <Grid item xs={6}>
              {!userBasedHideField() && <CmpCheckboxField
                xChecked={vRdxWmsHead.A_ECOM == "Y"}
                xOnChange={fonChangeInput_A_ECOM}
                xDisabled={true}
                xName={"ECOM"}
                xNameField={"ECOM"}
                xError={sErrorMsg?.A_ECOM === "" ? false : true}
                xErrorMessage={sErrorMsg?.A_ECOM}
                sales_onvoice_check_box="start"
              />}
            </Grid>
            <Grid item xs={6}>
              <CmpCheckboxField
                xChecked={vRdxWmsHead.A_Taxable == "Y"}
                xOnChange={fonChangeInputTaxable}
                xDisabled={true}
                xName={"A_Taxable"}
                xNameField={"Tax"}
                xError={sErrorMsg?.A_Taxable === "" ? false : true}
                xErrorMessage={sErrorMsg?.A_Taxable}
                sales_onvoice_check_box="start"
              />
            </Grid>

            <Grid item xs={6}>
              {!userBasedHideField() && <CmpCheckboxField
                xChecked={vRdxWmsHead.A_DropShipment == "Y"}
                xOnChange={fonChangeInput_A_DropShipment}
                xDisabled={false}
                xName={"A_DropShipment"}
                xNameField={"Drop Shipment"}
                xError={sErrorMsg?.A_DropShipment === "" ? false : true}
                xErrorMessage={sErrorMsg?.A_DropShipment}
                sales_onvoice_check_box="start"
              />}
            </Grid>
            <Grid item xs={6}>
             <CmpCheckboxField
                xChecked={vRdxWmsHead.CreditNote == "Y"}
                xOnChange={fonChangeInput_CreditNote}
                xDisabled={false}
                xName={"CreditNote"}
                xNameField={"Credit Note"}
                xError={sErrorMsg?.CreditNote === "" ? false : true}
                xErrorMessage={sErrorMsg?.CreditNote}
                sales_onvoice_check_box="start"
              />
            </Grid>
            <Grid item xs={6}>
             <CmpCheckboxField
                xChecked={vRdxWmsHead.Commity == "Y"}
                xOnChange={fonChangeInput_Commity}
                xDisabled={false}
                xName={"Commity"}
                xNameField={"commission"}
                xError={sErrorMsg?.Commity === "" ? false : true}
                xErrorMessage={sErrorMsg?.Commity}
                sales_onvoice_check_box="start"
              />
            </Grid>
            
           
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
